/**
 * Created by Ning Jiang on 9/15/2016.
 */

class DynamicTextsLine extends PIXI.Container {

    private _texts:PIXI.Text[];
    private _textSpacing:number = 0;

    get textSpacing():number {
        return this._textSpacing;
    }

    set textSpacing(value:number) {
        this._textSpacing = value;
    }

    constructor() {
        super();
        this._texts = [];
    }

    public createText(textString:string, style:any):PIXI.Text {
        let text:PIXI.Text = new PIXI.Text(textString, style);
        text.anchor.set(0, 0.5);
        text.y = 0;
        this._texts.push(text);
        this.addChild(text);

        return text;
    }

    public arrange() {
        let i:number;
        let totalWidth:number = this._textSpacing * (this._texts.length - 1);
        for(i = 0; i < this._texts.length; i++) {
            totalWidth += this._texts[i].width;
        }

        let positionX:number = -totalWidth / 2;
        for(i = 0; i < this._texts.length; i++) {
            this._texts[i].x = positionX;
            positionX += this._texts[i].width;
            positionX += this._textSpacing;
        }
    }
}

export {DynamicTextsLine};